import React, { Component } from "react";
import { connect } from "react-redux";
import { PageHeader, Tag, Descriptions, Card, Row, Col, Tabs, Image, Empty, Input, Popconfirm, Tooltip, message, Spin, List } from "antd";
import { EditOutlined, DeleteOutlined, SwapOutlined, PaperClipOutlined, ArrowLeftOutlined, ToolOutlined, AlertOutlined, QrcodeOutlined, ReloadOutlined, FilePdfOutlined, CalendarOutlined } from "@ant-design/icons";
import { ButtonItem, TableItem } from "../../../../../Components/Items";
import { cmmsPost, estatusEquipo, formatoFecha, formatoFechaHora, estatusServicio, estatusTicket, prioridad, minutosATexto, estatusPlan } from "../../cmmsComun";
import ModalEtiquetasCMMS from "../../componentes/ModalEtiquetasCMMS";
import ModalProgramarServicioCMMS from "../../componentes/ModalProgramarServicioCMMS";
import ModalPdfCMMS from "../../componentes/ModalPdfCMMS";
import { generarPdfCertificado } from "../../Certificados/pdfCertificado";
import { VIGENCIAS, etiquetaResultado } from "../../Certificados/certificadoComun";
import ModalTicket from "../../Tickets/ModalTicket";
import ModalActivo from "../ModalActivo";
import ModalTransferirActivo from "./ModalTransferirActivo";

const { TabPane } = Tabs;

const valorOVacio = (v) => (v === undefined || v === null || v === "" ? <span style={{ color: "#bfbfbf" }}>—</span> : v);

// Ficha (expediente) de un activo CMMS. Se abre con history.push("/panel/cmmsFichaActivo", { id }).
// Indicadores, historial de servicios y tickets vienen de cmms/historialActivoCMMS.
class FichaActivo extends Component {
    state = {
        loading: true,
        ficha: null,
        modalEditar: false,
        modalTransferir: false,
        textoNota: "",
        notaEditandoId: null,
        textoNotaEditando: "",
        historial: null,
        modalEtiqueta: false,
        modalTicket: false,
        planes: [],
        certificados: [],
        pdfCertificado: null,
    };

    get activoId() {
        return this.props.location?.state?.id;
    }

    componentDidMount() {
        if (!this.activoId) {
            this.props.history.push("/panel/cmmsActivos");
            return;
        }
        this.consultarFicha();
    }

    consultarFicha = async () => {
        this.setState({ loading: true });
        try {
            const res = await cmmsPost(this.props, "fichaActivoCMMS", { id: this.activoId });
            if (res.data.success === 2) this.setState({ ficha: res.data.ficha });
            else message.error(res.data.message || "No se encontró el activo");
            const [h, p, c] = await Promise.all([
                cmmsPost(this.props, "historialActivoCMMS", { activoId: this.activoId }),
                cmmsPost(this.props, "planesActivoCMMS", { activoId: this.activoId }),
                cmmsPost(this.props, "selectCertificadosCMMS", { activoId: this.activoId, valor: "todos" }),
            ]);
            if (h.data.success === 2) this.setState({ historial: h.data });
            if (p.data.success === 2) this.setState({ planes: p.data.planes });
            if (c.data.success === 2) this.setState({ certificados: c.data.certificados });
        } catch (error) {
            console.log(error);
            message.error("Error al consultar el activo");
        } finally {
            this.setState({ loading: false });
        }
    };

    // ─── Notas ──────────────────────────────────────────────────────────────
    agregarNota = async () => {
        const texto = this.state.textoNota.trim();
        if (!texto) return;
        const res = await cmmsPost(this.props, "agregarNotaActivoCMMS", { id: this.activoId, texto });
        if (res.data.success === 2) {
            this.setState({ textoNota: "" });
            this.consultarFicha();
        } else message.error(res.data.message || "No se pudo agregar la nota");
    };

    guardarNotaEditada = async () => {
        const texto = this.state.textoNotaEditando.trim();
        if (!texto) return;
        const res = await cmmsPost(this.props, "editarNotaActivoCMMS", { id: this.activoId, notaId: this.state.notaEditandoId, texto });
        if (res.data.success === 2) {
            this.setState({ notaEditandoId: null, textoNotaEditando: "" });
            this.consultarFicha();
        } else message.error(res.data.message || "No se pudo editar la nota");
    };

    eliminarNota = async (notaId) => {
        const res = await cmmsPost(this.props, "eliminarNotaActivoCMMS", { id: this.activoId, notaId });
        if (res.data.success === 2) this.consultarFicha();
        else message.error(res.data.message || "No se pudo eliminar la nota");
    };

    renderEncabezado(f) {
        const est = estatusEquipo(f.estatusEquipo);
        return (
            <Card style={{ marginBottom: 10 }} bodyStyle={{ padding: 16 }}>
                <Row gutter={16} align="middle">
                    <Col flex="96px">
                        {f.fotos?.[0] ? (
                            <Image width={88} height={88} style={{ objectFit: "cover", borderRadius: 8 }} src={f.fotos[0].url} />
                        ) : (
                            <div style={{ width: 88, height: 88, borderRadius: 8, background: "#f0f5f8", display: "flex", alignItems: "center", justifyContent: "center", color: "#8c8c8c", fontSize: 12 }}>
                                Sin foto
                            </div>
                        )}
                    </Col>
                    <Col flex="auto">
                        <div style={{ fontSize: 20, fontWeight: 600 }}>{f.tipoNombre}</div>
                        <div style={{ color: "#5b6b7c" }}>
                            {[f.marcaNombre, f.modeloNombre].filter(Boolean).join(" · ")}
                        </div>
                        <div style={{ marginTop: 6 }}>
                            <Tag color={est.color}>{est.label}</Tag>
                            <span style={{ marginRight: 16 }}>
                                <b>Folio:</b> {f.codigo}
                            </span>
                            <span style={{ marginRight: 16 }}>
                                <b>No. Serie:</b> {f.sinSerie ? "Sin serie" : f.numeroSerie || "—"}
                            </span>
                            {f.idExterno ? (
                                <span style={{ marginRight: 16 }}>
                                    <b>ID Externo:</b> {f.idExterno}
                                </span>
                            ) : null}
                            {f.idInterno ? (
                                <span>
                                    <b>ID Interno:</b> {f.idInterno}
                                </span>
                            ) : null}
                        </div>
                    </Col>
                    <Col>
                        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                            <ButtonItem type="primary" icon={<ToolOutlined />} onClick={() => this.props.history.push("/panel/cmmsServicio", { activoId: this.activoId })}>
                                Nuevo servicio
                            </ButtonItem>
                            <ButtonItem
                                type="default"
                                icon={<CalendarOutlined />}
                                onClick={() =>
                                    this.setState({
                                        modalProgramar: {
                                            _id: this.activoId,
                                            texto: [f.codigo, f.tipoNombre, f.marcaNombre, f.modeloNombre, f.sinSerie ? "Sin serie" : f.numeroSerie && `Serie ${f.numeroSerie}`].filter(Boolean).join(" · "),
                                        },
                                    })
                                }
                            >
                                Programar servicio
                            </ButtonItem>
                            <ButtonItem type="default" icon={<AlertOutlined />} onClick={() => this.setState({ modalTicket: true })}>
                                Abrir ticket
                            </ButtonItem>
                            <ButtonItem type="default" icon={<QrcodeOutlined />} onClick={() => this.setState({ modalEtiqueta: true })}>
                                Etiqueta
                            </ButtonItem>
                            <ButtonItem type="default" icon={<SwapOutlined />} onClick={() => this.setState({ modalTransferir: true })}>
                                Transferir
                            </ButtonItem>
                            <ButtonItem type="default" icon={<EditOutlined />} onClick={() => this.setState({ modalEditar: true })}>
                                Editar
                            </ButtonItem>
                        </div>
                    </Col>
                </Row>
            </Card>
        );
    }

    renderKpis() {
        const k = this.state.historial?.kpis;
        if (!k) return null;
        const tiles = [
            ["Preventivos concluidos", k.preventivosConcluidos],
            ["Reparaciones concluidas", k.reparacionesConcluidas],
            ["Tiempo promedio MPrev", minutosATexto(k.tiempoPromedioPreventivoMin) || "—"],
            ["MTTR (tiempo medio de reparación)", minutosATexto(k.mttrMin) || "—"],
            ["MTBF (días entre fallas)", k.mtbfDias !== null && k.mtbfDias !== undefined ? `${Math.round(k.mtbfDias)} días` : "—"],
            ["Tiempo máximo de atención", k.tiempoMaximoAtencionHrs !== null && k.tiempoMaximoAtencionHrs !== undefined ? `${Math.round(k.tiempoMaximoAtencionHrs)} h` : "—"],
            ["Ingreso del año", `$${Number(k.ingresoAnual || 0).toLocaleString("es-MX", { minimumFractionDigits: 2 })}`],
            ["Folio última OS preventiva", k.folioUltimoPreventivo || "—"],
            ["Folio última reparación", k.folioUltimaReparacion || "—"],
            ["Motivo de la última falla", k.motivoUltimaFalla || "—"],
        ];
        return (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))", gap: 8, marginBottom: 10 }}>
                {tiles.map(([etiqueta, valor]) => (
                    <div key={etiqueta} style={{ background: "#fff", border: "1px solid #eef1f4", borderRadius: 8, padding: "8px 12px" }}>
                        <div style={{ fontSize: 11, color: "#7a8794" }}>{etiqueta}</div>
                        <div style={{ fontSize: 15, fontWeight: 600, color: "#1f2a37", wordBreak: "break-word" }}>{valor}</div>
                    </div>
                ))}
            </div>
        );
    }

    renderHistorial() {
        const h = this.state.historial;
        if (!h) return <Empty description="Cargando historial..." />;
        return (
            <>
                <h4>Servicios ({h.servicios.length})</h4>
                <TableItem
                    size="small"
                    pagination={true}
                    dataSource={h.servicios}
                    onRow={(r) => ({ onDoubleClick: () => this.props.history.push("/panel/cmmsServicio", { id: r._id }) })}
                    columns={[
                        { title: "Folio", dataIndex: "codigo", key: "codigo", width: 110, render: (v, r) => (r.folioExterno ? `${r.folioExterno} (${v})` : v) },
                        { title: "Tipo", dataIndex: "tipoServicioNombre", key: "tipoServicioNombre", width: 190 },
                        { title: "Estatus", dataIndex: "estatus", key: "estatus", width: 110, render: (v) => <Tag color={estatusServicio(v).color}>{estatusServicio(v).label}</Tag> },
                        { title: "Fecha", dataIndex: "fechaConclusion", key: "fechaConclusion", width: 150, render: (v, r) => formatoFechaHora(v || r.fechaInicio || r.createdAt) },
                        { title: "Ingeniero", dataIndex: "empleadoNombre", key: "empleadoNombre", width: 180 },
                        { title: "Entrega", dataIndex: "condicionesEntrega", key: "condicionesEntrega", width: 150, render: (v) => (v?.estatus ? <Tag color={estatusEquipo(v.estatus).color}>{estatusEquipo(v.estatus).label}</Tag> : "") },
                        { title: "Refacciones", dataIndex: "partesTexto", key: "partesTexto" },
                    ]}
                />
                <h4 style={{ marginTop: 16 }}>Tickets ({h.tickets.length})</h4>
                <TableItem
                    size="small"
                    pagination={true}
                    dataSource={h.tickets}
                    columns={[
                        { title: "Folio", dataIndex: "codigo", key: "codigo", width: 110 },
                        { title: "Fecha", dataIndex: "fechaSolicitud", key: "fechaSolicitud", width: 150, render: (v) => formatoFechaHora(v) },
                        { title: "Tipo", dataIndex: "tipoSolicitud", key: "tipoSolicitud", width: 150 },
                        { title: "Prioridad", dataIndex: "prioridad", key: "prioridad", width: 170, render: (v) => <Tag color={prioridad(v).color}>{prioridad(v).label}</Tag> },
                        { title: "Estatus", dataIndex: "estatus", key: "estatus", width: 170, render: (v) => <Tag color={estatusTicket(v).color}>{estatusTicket(v).label}</Tag> },
                        { title: "Solicitud", dataIndex: "solicitud", key: "solicitud" },
                    ]}
                />
            </>
        );
    }

    regenerarQR = async () => {
        const res = await cmmsPost(this.props, "regenerarTokenActivoCMMS", { id: this.activoId });
        if (res.data.success === 2) message.success("Se generó un nuevo QR. Imprima una etiqueta nueva: la anterior ya no abre la ficha.");
        else message.error(res.data.message || "No se pudo regenerar el QR");
    };

    // "1ra Vuelta: Realizado · 2da Vuelta: 15 oct" (programa del contrato actual).
    planAnual(f) {
        const delContrato = this.state.planes.filter((p) => f.contrato && p.contratoId === f.contrato._id);
        if (!delContrato.length) return <span style={{ color: "#9aa7b4" }}>{f.contrato ? "Sin servicios en el programa" : "Por definir"}</span>;
        return (
            <span style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                {delContrato
                    .slice()
                    .sort((a, b) => (a.vueltaNombre || "").localeCompare(b.vueltaNombre || ""))
                    .map((p) => (
                        <Tag key={p._id} color={estatusPlan(p.estatusVisible).color}>
                            {p.vueltaNombre}: {p.estatusVisible === "calendarizado" ? formatoFecha(p.fechaPlaneada) : estatusPlan(p.estatusVisible).label}
                        </Tag>
                    ))}
            </span>
        );
    }

    renderProgramaActivo() {
        return (
            <TableItem
                size="small"
                pagination={true}
                dataSource={this.state.planes}
                rowKey="_id"
                locale={{ emptyText: "El equipo no tiene servicios calendarizados" }}
                columns={[
                    { title: "Fecha", dataIndex: "fechaPlaneada", key: "fechaPlaneada", width: 115, render: (v) => (v ? formatoFecha(v) : "Sin fecha") },
                    { title: "Contrato", dataIndex: "contratoNombre", key: "contratoNombre", render: (v, r) => (v ? `${v}${r.vueltaNombre ? ` · ${r.vueltaNombre}` : ""}` : "Agenda (sin contrato)") },
                    { title: "Tipo", dataIndex: "tipoServicioNombre", key: "tipoServicioNombre", width: 190 },
                    { title: "Ingeniero", dataIndex: "empleadoNombre", key: "empleadoNombre", width: 170 },
                    { title: "Folio externo", dataIndex: "folioExterno", key: "folioExterno", width: 150 },
                    {
                        title: "Estatus",
                        dataIndex: "estatusVisible",
                        key: "estatusVisible",
                        width: 150,
                        render: (v, r) => (
                            <Tooltip title={r.motivoNoRealizado || ""}>
                                <Tag color={estatusPlan(v).color}>{estatusPlan(v).label}</Tag>
                            </Tooltip>
                        ),
                    },
                    {
                        title: "",
                        key: "accion",
                        width: 140,
                        render: (r) =>
                            r.servicioId ? (
                                <ButtonItem type="link" size="small" onClick={() => this.props.history.push("/panel/cmmsServicio", { id: r.servicioId })}>
                                    {r.servicioCodigo || "Ver servicio"}
                                </ButtonItem>
                            ) : r.estatus === 1 ? (
                                <ButtonItem type="link" size="small" icon={<ToolOutlined />} onClick={() => this.props.history.push("/panel/cmmsServicio", { planId: r._id })}>
                                    Iniciar servicio
                                </ButtonItem>
                            ) : null,
                    },
                ]}
            />
        );
    }

    renderDatos(f) {
        return (
            <Card style={{ marginBottom: 10 }} bodyStyle={{ padding: 0 }}>
                <Descriptions bordered size="small" column={{ xs: 1, md: 2, xl: 3 }}>
                    <Descriptions.Item label="Cliente">{f.clienteId ? f.clienteNombre : <Tag>Sin cliente</Tag>}</Descriptions.Item>
                    <Descriptions.Item label="Contrato">
                        {f.contrato ? (
                            <span>
                                <ButtonItem type="link" style={{ padding: 0, height: "auto" }} onClick={() => this.props.history.push("/panel/cmmsContrato", { id: f.contrato._id })}>
                                    {f.contrato.nombre}
                                </ButtonItem>{" "}
                                <Tag color={f.contrato.estatusColor}>{f.contrato.estatusNombre}</Tag>
                            </span>
                        ) : (
                            <span style={{ color: "#9aa7b4" }}>Sin contrato (se atiende por evento)</span>
                        )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Sucursal">{valorOVacio(f.sucursalNombre)}</Descriptions.Item>
                    <Descriptions.Item label="Ubicación / Área">{valorOVacio([f.ubicacionNombre, f.area].filter(Boolean).join(" · "))}</Descriptions.Item>
                    <Descriptions.Item label="Categoría">{valorOVacio(f.categoria)}</Descriptions.Item>
                    <Descriptions.Item label="Pertenencia">{valorOVacio(f.pertenencia)}</Descriptions.Item>
                    <Descriptions.Item label="Jerarquía">{valorOVacio(f.jerarquia)}</Descriptions.Item>
                    <Descriptions.Item label="Tiempo máx. de respuesta">{valorOVacio(f.tiempoMaximoRespuestaHrs || f.tiempoMaximoRespuestaHrs === 0 ? `${f.tiempoMaximoRespuestaHrs} horas` : "")}</Descriptions.Item>
                    <Descriptions.Item label="No. Inventario">{valorOVacio(f.numeroInventario)}</Descriptions.Item>
                    <Descriptions.Item label="Fecha de alta">{formatoFecha(f.createdAt)}</Descriptions.Item>
                    <Descriptions.Item label="Fecha de instalación">{valorOVacio(formatoFecha(f.fechaInstalacion))}</Descriptions.Item>
                    <Descriptions.Item label="Inicio de garantía">{valorOVacio(formatoFecha(f.inicioGarantia))}</Descriptions.Item>
                    <Descriptions.Item label="Fin de garantía">{valorOVacio(formatoFecha(f.finGarantia))}</Descriptions.Item>
                    <Descriptions.Item label="Fecha de venta">{valorOVacio(formatoFecha(f.fechaVenta))}</Descriptions.Item>
                    <Descriptions.Item label="Último preventivo">{valorOVacio(formatoFecha(f.fechaUltimoPreventivo))}</Descriptions.Item>
                    <Descriptions.Item label="Próximo preventivo">{valorOVacio(formatoFecha(f.fechaProximoPreventivo))}</Descriptions.Item>
                    <Descriptions.Item label="Última reparación">{valorOVacio(formatoFecha(f.fechaUltimaReparacion))}</Descriptions.Item>
                    <Descriptions.Item label="Preventivo cada">{valorOVacio(f.periodicidadMeses ? `${f.periodicidadMeses} meses` : "")}</Descriptions.Item>
                    <Descriptions.Item label="Tiempo estimado MPrev">{valorOVacio(f.duracionEstimadaMin ? `${f.duracionEstimadaMin} min` : "")}</Descriptions.Item>
                    <Descriptions.Item label="Plan anual de servicio">{this.planAnual(f)}</Descriptions.Item>
                </Descriptions>
                {f.descripcion ? <div style={{ padding: "10px 16px", color: "#5b6b7c" }}>{f.descripcion}</div> : null}
            </Card>
        );
    }

    renderNotas(f) {
        return (
            <>
                <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                    <Input.TextArea
                        rows={2}
                        placeholder="Escriba una nota y presione Agregar"
                        value={this.state.textoNota}
                        onChange={(e) => this.setState({ textoNota: e.target.value })}
                    />
                    <ButtonItem type="primary" htmlType="button" onClick={this.agregarNota} disabled={!this.state.textoNota.trim()}>
                        Agregar
                    </ButtonItem>
                </div>
                <List
                    locale={{ emptyText: "Sin notas" }}
                    dataSource={f.notas || []}
                    renderItem={(n) => (
                        <List.Item
                            actions={
                                this.state.notaEditandoId === n._id
                                    ? [
                                          <ButtonItem key="g" type="link" size="small" onClick={this.guardarNotaEditada}>
                                              Guardar
                                          </ButtonItem>,
                                          <ButtonItem key="c" type="link" size="small" onClick={() => this.setState({ notaEditandoId: null })}>
                                              Cancelar
                                          </ButtonItem>,
                                      ]
                                    : [
                                          <Tooltip key="e" title="Editar">
                                              <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} onClick={() => this.setState({ notaEditandoId: n._id, textoNotaEditando: n.texto })} />
                                          </Tooltip>,
                                          <Popconfirm key="d" title="¿Eliminar esta nota?" onConfirm={() => this.eliminarNota(n._id)} okText="Sí" cancelText="No">
                                              <ButtonItem type="default" size="small" rojo icon={<DeleteOutlined />} />
                                          </Popconfirm>,
                                      ]
                            }
                        >
                            <List.Item.Meta
                                title={
                                    <span style={{ fontSize: 12, color: "#8c8c8c" }}>
                                        {formatoFecha(n.fecha)} · {n.autorNombre || "—"}
                                        {n.editadoEn ? " · editada" : ""}
                                    </span>
                                }
                                description={
                                    this.state.notaEditandoId === n._id ? (
                                        <Input.TextArea rows={2} value={this.state.textoNotaEditando} onChange={(e) => this.setState({ textoNotaEditando: e.target.value })} />
                                    ) : (
                                        <span style={{ color: "#1f2a37", whiteSpace: "pre-wrap" }}>{n.texto}</span>
                                    )
                                }
                            />
                        </List.Item>
                    )}
                />
            </>
        );
    }

    renderArchivos(f) {
        const enlaces = (lista) =>
            lista.length ? (
                lista.map((a) => (
                    <div key={a.uid}>
                        <a href={a.url} target="_blank" rel="noopener noreferrer">
                            <PaperClipOutlined /> {a.name}
                        </a>
                    </div>
                ))
            ) : (
                <span style={{ color: "#bfbfbf" }}>Sin archivos</span>
            );
        return (
            <Row gutter={16}>
                <Col xs={24} md={12}>
                    <h4>Fotos</h4>
                    {f.fotos?.length ? (
                        <Image.PreviewGroup>
                            {f.fotos.map((foto) => (
                                <Image key={foto.uid} width={110} height={110} style={{ objectFit: "cover", marginRight: 8, marginBottom: 8 }} src={foto.url} />
                            ))}
                        </Image.PreviewGroup>
                    ) : (
                        <span style={{ color: "#bfbfbf" }}>Sin fotos</span>
                    )}
                </Col>
                <Col xs={24} md={12}>
                    <h4>Documentos y manuales</h4>
                    {enlaces(f.archivos || [])}
                </Col>
            </Row>
        );
    }

    render() {
        const f = this.state.ficha;
        return (
            <>
                <PageHeader
                    title="Ficha del Activo"
                    subTitle={f ? f.codigo : ""}
                    onBack={() => this.props.history.push("/panel/cmmsActivos")}
                    backIcon={<ArrowLeftOutlined />}
                    extra={
                        <Popconfirm
                            title="¿Generar un QR nuevo? Las etiquetas ya impresas dejarán de funcionar."
                            onConfirm={this.regenerarQR}
                            okText="Sí, generar"
                            cancelText="No"
                        >
                            <ButtonItem type="link" blanco icon={<ReloadOutlined />}>
                                Regenerar QR
                            </ButtonItem>
                        </Popconfirm>
                    }
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
                />
                <Spin spinning={this.state.loading}>
                    {!f ? (
                        !this.state.loading && <Empty description="No se encontró el activo" />
                    ) : (
                        <>
                            {this.renderEncabezado(f)}
                            {this.renderKpis()}
                            {this.renderDatos(f)}
                            <Card bodyStyle={{ paddingTop: 4 }}>
                                <Tabs defaultActiveKey="historial">
                                    <TabPane tab="Historial" key="historial">
                                        {this.renderHistorial()}
                                    </TabPane>
                                    <TabPane tab={`Programa (${this.state.planes.length})`} key="programa">
                                        {this.renderProgramaActivo()}
                                    </TabPane>
                                    <TabPane tab={`Certificados (${this.state.certificados.filter((c) => c.estatus === 1).length})`} key="certificados">
                                        <TableItem
                                            size="small"
                                            pagination={true}
                                            rowKey="_id"
                                            dataSource={this.state.certificados}
                                            locale={{ emptyText: "Sin certificados: se emiten desde la Orden de Servicio (paso Certificados)." }}
                                            onRow={(r) => ({ onDoubleClick: () => this.setState({ pdfCertificado: r }) })}
                                            columns={[
                                                { title: "Folio", dataIndex: "codigo", key: "codigo", width: 110 },
                                                { title: "Certificado", dataIndex: "nombre", key: "nombre", render: (v, r) => [v, r.clave].filter(Boolean).join(" · ") },
                                                { title: "O.S.", dataIndex: "servicioCodigo", key: "servicioCodigo", width: 110 },
                                                { title: "Fecha", dataIndex: "fecha", key: "fecha", width: 110, render: (v) => formatoFecha(v) },
                                                {
                                                    title: "Vigente hasta",
                                                    dataIndex: "vigenciaHasta",
                                                    key: "vigenciaHasta",
                                                    width: 200,
                                                    render: (v, r) =>
                                                        r.estatus === 0 ? (
                                                            <Tag>Cancelado</Tag>
                                                        ) : (
                                                            <span>
                                                                {formatoFecha(v)} {r.estatusVigencia && <Tag color={VIGENCIAS[r.estatusVigencia].color}>{VIGENCIAS[r.estatusVigencia].label}</Tag>}
                                                                {r.renovado && r.estatusVigencia !== "vigente" ? <Tag color="blue">Renovado</Tag> : null}
                                                            </span>
                                                        ),
                                                },
                                                { title: "Resultado", dataIndex: "cumple", key: "cumple", width: 130, render: (v, r) => <Tag color={etiquetaResultado(v, r.pendientes, r.otorgado).color}>{etiquetaResultado(v, r.pendientes, r.otorgado).label}</Tag> },
                                                {
                                                    title: "",
                                                    key: "pdf",
                                                    width: 60,
                                                    render: (r) => (
                                                        <Tooltip title="Ver / descargar PDF">
                                                            <ButtonItem type="default" size="small" cyan icon={<FilePdfOutlined />} onClick={() => this.setState({ pdfCertificado: r })} />
                                                        </Tooltip>
                                                    ),
                                                },
                                            ]}
                                        />
                                    </TabPane>
                                    <TabPane tab={`Notas (${(f.notas || []).length})`} key="notas">
                                        {this.renderNotas(f)}
                                    </TabPane>
                                    <TabPane tab="Fotos y archivos" key="archivos">
                                        {this.renderArchivos(f)}
                                    </TabPane>
                                    <TabPane tab={`Transferencias (${(f.transferencias || []).length})`} key="transferencias">
                                        <TableItem
                                            size="small"
                                            pagination={true}
                                            dataSource={f.transferencias || []}
                                            columns={[
                                                { title: "Fecha", dataIndex: "fecha", key: "fecha", width: 120, render: (v) => formatoFecha(v) },
                                                { title: "De", dataIndex: "deTexto", key: "deTexto" },
                                                { title: "A", dataIndex: "aTexto", key: "aTexto" },
                                                { title: "Motivo", dataIndex: "motivo", key: "motivo" },
                                                { title: "Usuario", dataIndex: "usuarioNombre", key: "usuarioNombre", width: 160 },
                                            ]}
                                        />
                                    </TabPane>
                                </Tabs>
                            </Card>
                        </>
                    )}
                </Spin>

                <ModalEtiquetasCMMS visible={this.state.modalEtiqueta} ids={[this.activoId]} onClose={() => this.setState({ modalEtiqueta: false })} />
                <ModalProgramarServicioCMMS
                    {...this.props}
                    visible={!!this.state.modalProgramar}
                    activoInicial={this.state.modalProgramar}
                    onCerrar={(ok) => this.setState({ modalProgramar: null }, () => ok && this.consultarFicha())}
                />
                <ModalPdfCMMS
                    visible={!!this.state.pdfCertificado}
                    titulo={`Certificado ${this.state.pdfCertificado?.codigo || ""}`}
                    nombreArchivo={`Certificado_${this.state.pdfCertificado?.codigo || ""}.pdf`}
                    generar={() => generarPdfCertificado(this.props, this.state.pdfCertificado._id)}
                    onClose={() => this.setState({ pdfCertificado: null })}
                />
                <ModalTicket
                    visible={this.state.modalTicket}
                    activoIdInicial={this.activoId}
                    onClose={(creado) => this.setState({ modalTicket: false }, () => creado && this.consultarFicha())}
                />
                <ModalActivo
                    visible={this.state.modalEditar}
                    modo="editar"
                    activoId={this.activoId}
                    onClose={() => this.setState({ modalEditar: false }, this.consultarFicha)}
                />
                <ModalTransferirActivo
                    visible={this.state.modalTransferir}
                    activoId={this.activoId}
                    ubicacionActual={f ? [f.clienteId ? f.clienteNombre : "Sin cliente", f.sucursalNombre, f.ubicacionNombre, f.area].filter(Boolean).join(" · ") : ""}
                    onClose={(transferido) =>
                        this.setState({ modalTransferir: false }, () => {
                            if (transferido) this.consultarFicha();
                        })
                    }
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(FichaActivo);
